import styled from '@emotion/styled'
import { Button, Checkbox, Flex, Text, useToastPopup } from '@collable/ui'
import SignupContentHeader from './ContentHeader'
import { useSignupProgressContext } from '@/context/SignupProgressContext'
import { type FormEvent, useState } from 'react'
import PersonalAuthenticationContent from './PersonalAuthenticationContent'
import { useSignup } from '@/api/auth'
import { useNavigate } from 'react-router'

const SignupPersonalAuthentication = () => {
  const navigate = useNavigate()
  const { mutate: signup } = useSignup()
  const { addToastPopup } = useToastPopup()
  const { signupInfo, onChangeSignupInfo } = useSignupProgressContext()
  const [errorInputs, setErrorInputs] = useState<string[]>([])

  const [personalAuthenticationSuccess, setPersonalAuthenticationSuccess] = useState(false)

  const submitBtnDisabled =
    !signupInfo?.serviceAgree ||
    !signupInfo?.name ||
    !signupInfo?.phoneNumber ||
    !personalAuthenticationSuccess

  const onSuccessSignup = () => {
    addToastPopup({
      type: 'normal',
      status: 'positive',
      message: '정상적으로 가입에 성공했습니다.',
    })
    navigate('/channels/verify')
  }

  const onErrorSignup = (errorMessage: string) => {
    if (errorMessage === '기존에 가입된 번호가 있습니다.')
      setErrorInputs(prev => prev.concat('phoneNumber'))
  }

  const onClickSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!signupInfo) return

    signup(signupInfo, {
      onSuccess: onSuccessSignup,
      onError: err => onErrorSignup(err.response?.data.message ?? ''),
    })
  }

  return (
    <Container onSubmit={onClickSubmit}>
      <SignupContentHeader />
      <Content direction="column" gap={20}>
        <PersonalAuthenticationContent
          errorInputs={errorInputs}
          setErrorInputs={setErrorInputs}
          setPersonalAuthenticationSuccess={setPersonalAuthenticationSuccess}
          personalAuthenticationSuccess={personalAuthenticationSuccess}
        />
        <Text size="body2" color="labelAlternative">
          약관 동의
        </Text>
        <AgreeTerms direction="column" gap={12}>
          <Flex gap={8} as="label">
            <Checkbox
              size="large"
              checked={signupInfo?.serviceAgree ?? false}
              onChange={() => onChangeSignupInfo('serviceAgree', !signupInfo?.serviceAgree)}
            />
            <Text size="body1">(필수) 서비스 이용 약관에 동의합니다.</Text>
          </Flex>
          <Flex gap={8} as="label">
            <Checkbox
              size="large"
              checked={signupInfo?.marketingAgree ?? false}
              onChange={() => onChangeSignupInfo('marketingAgree', !signupInfo?.marketingAgree)}
            />
            <Text size="body1">(선택) 마케팅 정보 및 혜택 안내 수신에 동의합니다.</Text>
          </Flex>
        </AgreeTerms>
      </Content>
      <Button
        disabled={submitBtnDisabled}
        size="large"
        width="100%"
        type="submit"
        color="neutral"
        kind="solid"
        onClick={() => {}}
      >
        가입하기
      </Button>
    </Container>
  )
}

export default SignupPersonalAuthentication

const Container = styled.form`
  width: 600px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.common.commonWhite};
  padding: 28px;

  > button {
    margin-top: 28px;
  }
`

const Content = styled(Flex)`
  margin-top: 40px;
`

const AgreeTerms = styled(Flex)``
